import { AppList, AppTitle } from 'components/atoms';
import { WeeklyScheduleEntryDTO } from 'types/schedule/weeklySchedule';
import { useTheme } from 'styled-components';
import { WeeklyScheduleEntryItem } from './WeeklyScheduleEntryItem/WeeklyScheduleEntryItem';

type WeeklyScheduleEntriesListProps = {
    entries: WeeklyScheduleEntryDTO[];
};

export const WeeklyScheduleEntriesList = ({ entries }: WeeklyScheduleEntriesListProps) => {
    const theme = useTheme();

    if (!entries || entries.length === 0) {
        return null;
    }

    return (
        <>
            <AppTitle level={4} textAlign="center" margin={0} marginTop={32} marginBottom={16}>
                Historia planów tygodniowych
            </AppTitle>
            <AppList
                dataSource={entries}
                marginTop={theme.sizes.marginNormal}
                renderItem={(entry: WeeklyScheduleEntryDTO) => (
                    <WeeklyScheduleEntryItem entry={entry} />
                )}
            />
        </>
    );
};
